// An output window's mapped picture: the active map (or the editor's draft of it, or a drag's held frame) from `store`, with the editor's guides over it.
import { guidesWithCursor, subscribeMapCursor } from '~/lib/map/cursor'
import { heldMap, subscribeHeldMap } from '~/lib/map/held'
import { selectOutputCard, selectShownGuides, selectShownMap } from '~/store/maps/selectors'
import { mountMapRender } from '.'

const watched = s => [selectShownMap(s), selectOutputCard(s), selectShownGuides(s)]

export const mountActiveMapRender = ({ store, ...opts }) =>
	mountMapRender({
		...opts,
		read: () => {
			const s = store.getState()
			return {
				data: heldMap() ?? selectShownMap(s),
				card: selectOutputCard(s),
				guides: guidesWithCursor(selectShownGuides(s)),
				pin: true,
			}
		},
		subscribe: cb => {
			let seen = []
			const offStore = store.subscribe(() => {
				const now = watched(store.getState())
				if (now.every((v, i) => v === seen[i])) return
				seen = now
				cb()
			})
			const offHeld = subscribeHeldMap(cb)
			const offCursor = subscribeMapCursor(cb)
			return () => {
				offStore()
				offHeld()
				offCursor()
			}
		},
	})
